/*
 Created by CHT 2020/9/18 10:18
 复选 || 图片多选
 */
import {
  DATA_TYPE__ARRAY,
  FORM_ITEM__CHECKBOX,
  LAYOUT_TYPE__HOR,
  LAYOUT_TYPE__VER,
  SHOW_MODE__TILE,
  SHOW_MODE__DROP_DOWN,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__RELATE_DATA, FORM_ITEM__TABLE
} from '../types'
import { uuid, defaultValueInit } from '../utils'
import BaseItem from '../BaseItem'

class Checkbox extends BaseItem {

  constructor () {
    super()
    this.value = []
    this.options = [
      Checkbox.createOption('选项1'),
      Checkbox.createOption('选项2'),
      Checkbox.createOption('选项3')
    ]
    this.limitQuota = 0               // 是否限制配额 0 否 1 是

    this.chooseNumLimit = 0           // 0 不限制 1 限制
    this.minChoose = 0                // 最少选择多少项
    this.maxChoose = 0                // 最多选择多少项

    this.layoutType = this.layoutTypeList[0].value
    this.showMode = this.showModeList[0].value
    this.showColor = 1

    this.defaultValue = {
      defaultType: ''
    }
    this.optColorChange = 0 // 本地标记opt颜色发生变化，不提交服务器

    this.optionsType = 'custom' // custom 自定义，openApi，otherForm 关联其他表单数据， relateData 关联数据

    this.requestUrl = "" // 请求的url 可以添加控件字段
    this.methodType = 0 // 0 get 1 post
    this.headerList = [
      /*
      {
        "headerKey":"",
        "headerValue":"",
        "valueType":0, // 0 直接输入 1 表单获取
        "appId":"",
        "formId":"",
        "filterInfo":{
          "relation":"and",  //条件之间的关系 and查询 或者 or 查询
          "notJumpEmpty":0, //是否不跳过空值过滤 0 跳过 1 不跳过
          "conditionList":[
            {
              "type":"number", //控件的类型
              "method":"eq", //匹配的方法
              "value":[  //匹配的值
                25
              ],
              "fieldId":"控件的Id" //当时子表单的控件时 需要为"tableFiledId.subFiledId"
            }
          ]
        }//过滤器 结果取第一条
      }
       */
    ]
    this.paramType = 0 // 0 json 1 x-www-form-urlencoded
    this.paramList = [
      /*
      {
        "paramKey":"123123",
        "type":0, // 0 自定义 1 字段
        "paramValue":"13123123123", //自定义的值
        "fieldId":"控件的Id"
      }
       */
    ] //x-www-form-urlencoded 类型
    this.requestBody = ""   // 请求body 可以添加控件字段 json 类型取此参数
    this.resultList = [
      /*
      {
        "resultId":"前端生成Id",
        "resultAlias":"结果别名",
        "findType":0, // 0 jsonPath 目前只支持jsonPath
        "jsonPath":"jsonPathStr"
      }
       */
    ] //结果提取
    this.updateList = [
      /*
      {
        "resultId":"结果提取的Id",
        "fieldId":"控件的Id"
      }
       */
    ]

    this.relateAppId = ''   // 关联的AppId
    this.relateFormId = ''  // 关联的表单Id
    this.relateFieldId = '' // 关联的字段Id
    this.enableLimitCount = 0  // 0 不限制 1 限制最大
    this.limitCount = 100     // 限制个数
    this.sortList = [
      {
        fieldId: "",
        sortType: -1, //-1 倒序 1 正序
      }
    ]
    this.filterInfo = {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    }
    this.relateDataSourceType = 0
    //高级筛选条件 数据的二次筛选
    this.advancedFilter = 0
    this.tableFieldId = ''
    //二次的筛选条件
    this.advancedFilterInfo = {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    }
    this.openUnique = 'OPEN' // 数据来源字段去重 OPEN 开启 CLOSE 关闭 null的时候兼容为 OPEN

    this.currentTableId = ''
    this.dataFieldId = ''
  }

  get title () {
    return this.fieldTitle || Checkbox._title
  }

  set title (val) {
    this.fieldTitle = val
  }
}

Checkbox._title = '复选框'
Checkbox.type = FORM_ITEM__CHECKBOX
Checkbox.use = true
Checkbox.icon = 'iconfont icon-checkbox'

Checkbox.createOption = function (name) {
  return {
    optionName: name || '未命名',
    optionImage: '',
    chooseLimit: 0,     //  配额 可以选多少次
    defaultSelect: 0,   //  是否是默认选中
    alertText: '',      //  提示文案
    color: '#63B2EE',
    id: name || '未命名'
  }
}

Checkbox.prototype.type = Checkbox.type
Checkbox.prototype.dataType = DATA_TYPE__ARRAY
Checkbox.prototype.layoutTypeList = [
  {
    value: LAYOUT_TYPE__HOR,
    label: '水平'
  },
  {
    value: LAYOUT_TYPE__VER,
    label: '垂直'
  }
]
Checkbox.prototype.showModeList = [
  {
    value: SHOW_MODE__DROP_DOWN,
    label: '下拉'
  },
  {
    value: SHOW_MODE__TILE,
    label: '平铺'
  }
]
Checkbox.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM, [])
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
Checkbox.prototype.filterOpts = [
  {
    name: '包含任意一个',
    method: 'in'
  },
  {
    name: '同时包含',
    method: 'all'
  },
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Checkbox.prototype.getValue = function () {
  return this.value
}
Checkbox.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  if (val) {
    this.value.splice(0, this.value.length, ...val)
  } else {
    this.value.splice(0, this.value.length)
  }
}
Checkbox.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    options: this.options,
    limitQuota: this.limitQuota,
    chooseNumLimit: this.chooseNumLimit,
    minChoose: this.minChoose,
    maxChoose: this.maxChoose,
    layoutType: this.layoutType,
    showMode: this.showMode,
    showColor: this.showColor,
    defaultValue: this.defaultValue,

    optionsType: this.optionsType,

    requestUrl: this.requestUrl,
    methodType: this.methodType,
    headerList: this.headerList,
    paramType: this.paramType,
    paramList: this.paramList,
    requestBody: this.requestBody,
    resultList: this.resultList,
    updateList: this.updateList,

    relateAppId: this.relateAppId,
    relateFormId: this.relateFormId,
    relateFieldId: this.relateFieldId,
    enableLimitCount: this.enableLimitCount,
    limitCount: this.limitCount,
    sortList: this.sortList,
    filterInfo: this.filterInfo,
    advancedFilter: this.advancedFilter,
    tableFieldId: this.tableFieldId,
    advancedFilterInfo: this.advancedFilterInfo,
    relateDataSourceType: this.relateDataSourceType,
    openUnique: this.openUnique,
    currentTableId: this.currentTableId,
    dataFieldId: this.dataFieldId
  }
}
Checkbox.prototype.setConf = function (opts) {
  this.setBase(opts)

  if (opts.options) this.options = opts.options
  if (opts.limitQuota) this.limitQuota = opts.limitQuota
  if (opts.chooseNumLimit) this.chooseNumLimit = opts.chooseNumLimit
  if (opts.minChoose) this.minChoose = opts.minChoose
  if (opts.maxChoose) this.maxChoose = opts.maxChoose
  this.showColor = opts.showColor === 0 ? 0 : 1
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
  if (
    this.layoutTypeList
      .map(item => item.value)
      .includes(opts.layoutType)
  ) {
    this.layoutType = opts.layoutType
  }
  if (
    this.showModeList
      .map(item => item.value)
      .includes(opts.showMode)
  ) {
    this.showMode = opts.showMode
  }

  if (opts.optionsType) this.optionsType = opts.optionsType

  if (opts.requestUrl) this.requestUrl = opts.requestUrl
  this.methodType = opts.methodType || 0
  if (opts.headerList) this.headerList = opts.headerList
  this.paramType = opts.paramType || 0
  if (opts.paramList) this.paramList = opts.paramList
  if (opts.requestBody) this.requestBody = opts.requestBody
  if (opts.resultList) this.resultList = opts.resultList
  if (opts.updateList) this.updateList = opts.updateList

  if (opts.relateAppId) this.relateAppId = opts.relateAppId
  if (opts.relateFormId) this.relateFormId = opts.relateFormId
  if (opts.relateFieldId) this.relateFieldId = opts.relateFieldId
  if (opts.enableLimitCount) this.enableLimitCount = opts.enableLimitCount
  if (opts.limitCount) this.limitCount = opts.limitCount
  if (opts.sortList) this.sortList = opts.sortList
  if (opts.filterInfo) this.filterInfo = opts.filterInfo
  if (opts.advancedFilter) this.advancedFilter = opts.advancedFilter
  if (opts.tableFieldId) this.tableFieldId = opts.tableFieldId
  if (opts.advancedFilterInfo) this.advancedFilterInfo = opts.advancedFilterInfo
  this.relateDataSourceType = opts.relateDataSourceType
  this.openUnique = opts.openUnique || 'OPEN'
  if (opts.currentTableId) this.currentTableId = opts.currentTableId
  if (opts.dataFieldId) this.dataFieldId = opts.dataFieldId
}
Checkbox.prototype.addOpt = function (name) {
  if (!name) {
    const names = this.options.map(item => item.optionName)
    for (let i = 1; i < 1000; i++) {
      const currentName = `选项${i}`
      if (!names.includes(currentName)) {
        name = currentName
        break
      }
    }
  }
  this.options.push(Checkbox.createOption(name))
}
Checkbox.prototype.valueToString = function (value) {
  value = value || this.value
  // return  this.options
  //   .filter(opt => value.includes(opt.id))
  //   .map(opt=> opt.optionName)
  //   .join('、')
  // return value.join('、')
  const valueOpts = []
  value.forEach(item => {
    if (!item.startsWith('其他_other_')) {

      if (item === '其他') {
        const otherValue = value.filter(v => v.startsWith('其他_other_'))[0]
        if(otherValue) {
          valueOpts.push(`其他:${otherValue.substring(9, otherValue.length)}`)
        } else {
          valueOpts.push(`其他:`)
        }
      } else {
        valueOpts.push(item)
      }
    }
  })
  return valueOpts.join('、')
}
export default Checkbox
